import React from 'react';
import { observer } from 'mobx-react';
import { Page, Pane, PaneHeader } from '../../components/atoms/applications/page';
import './homeLocationUpdatePage.module.scss';
import { HomeLocationSelector } from '../../components/organisms/home_locations/HomeLocationSelector';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { LoaderRow } from '../../components/atoms/layout/LoaderRow';
import { HomeLocationUpdatePageState } from './states/HomeLocationUpdatePageState';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import { withNavigation } from '../../components/hocs/withNavigation';
import { NavigationSpecs } from '../../states/NavigationState';
import { BreadCrumb } from '../breadcrumb/BreadCrumb';

const Content = observer(({ pageState }: { pageState: HomeLocationUpdatePageState }) => {
  const { loading, homeLocation, selectedLocationId, selectLocation, baseList, submit, submitting } = pageState;
  if (loading) {
    return <LoaderRow />;
  }
  return (
    <div styleName="body">
      <HomeLocationSelector
        currentLocationOnline={homeLocation.isHomeLocationSet && !homeLocation.locationId}
        currentLocationId={homeLocation.locationId}
        selectedLocationId={selectedLocationId}
        onSelect={selectLocation}
        locations={baseList.baseList}
      />
      <div styleName="button-wrapper">
        <Button
          id="home-location-submit"
          type="primary"
          size="l"
          styleName="button"
          disabled={selectedLocationId != null && selectedLocationId < 0}
          onClick={submit}
          loading={submitting}
        >
          保存する
        </Button>
      </div>
    </div>
  );
});

export const HomeLocationUpdatePage = withNavigation(NavigationSpecs.side())(
  observer(
    class HomeLocationUpdatePage extends React.Component {
      pageState = new HomeLocationUpdatePageState(GlobalStatesV3.currentUser.homeLocation);
      async componentDidMount() {
        await this.pageState.init();
      }
      render() {
        const breadCrumbItems = [{ text: 'ホーム拠点変更' }];
        return (
          <Page>
            <Pane styleName="pane">
              <PaneHeader title="ホーム拠点の選択">
                <BreadCrumb items={breadCrumbItems} hasHome />
              </PaneHeader>
              <div styleName="text">
                ご都合に合わせてどの拠点もご自由にお使いいただけますが、スムーズな運営を行うために最も多く利用する予定の拠点(ホーム拠点)の選択をしてください。
                どの拠点を選択いただいても全ての拠点利用が可能なのでご安心ください。
                また、ホーム拠点はマイページからいつでも変更することができます。
              </div>
              <Content pageState={this.pageState} />
            </Pane>
          </Page>
        );
      }
    }
  )
);
